// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.P_ouW3Z4aZc0sg7gBxwj{background-color:var(--background-neutral-primary);border-radius:50%}.vXwFXmbItK001Eq9yPgQ{background-image:linear-gradient(90deg,var(--background-neutral-primary)25%,var(--background-neutral-subtle)50%,var(--background-neutral-primary)75%);background-size:200% 100%;animation:1.4s ease-in-out infinite TSIPdnkZGkkWmsnqzZqY}@media (prefers-reduced-motion:reduce){.vXwFXmbItK001Eq9yPgQ{animation:none}}@keyframes TSIPdnkZGkkWmsnqzZqY{0%{background-position:200% 0}to{background-position:-200% 0}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `P_ouW3Z4aZc0sg7gBxwj`,
	"animated": `vXwFXmbItK001Eq9yPgQ`,
	"shimmer": `TSIPdnkZGkkWmsnqzZqY`
};
export default ___CSS_LOADER_EXPORT___;
